import { useSelector } from 'react-redux';

import Global from '../store/global-selectors';
import { CA } from '../constants/country-codes';

/**
 * Hook to determine if the seller's home country is Canada
 * @returns {boolean} True if the seller is Canadian, false otherwise
 */
export const useIsCanadian = () => {
  const includedCountries = [CA];
  const sellerHomeCountry = useSelector(Global.selectSellerHomeCountry);
  return includedCountries.includes(sellerHomeCountry);
};
